import { useNavigate } from 'react-router-dom';
import logo from '../assets/images/1.png';
import Navbar from '../components/navbar';
import Footer from '../components/footer';

const Terms = () => {
    const navigate = useNavigate();

    return (
        <div className="layout">
            <Navbar />

            <div className='termsBox'>


            <h1>Terms of Use</h1>

            <p>
               
                <br /><br />

                Welcome to KWHour. By accessing or using our website, you agree to the following Terms of Use. 
                If you do not agree with these terms, please do not use the website.
                <br /><br />

                <strong>1. About This Website</strong>
                <br />
                KWHour provides general information about solar energy solutions and related services. 
                The content on this website is for informational and promotional purposes only and does not 
                constitute professional advice.
                <br /><br />

                <strong>2. No User Accounts or Cookies</strong>
                <br />
                This website does not:
                <br />
                – require users to create accounts<br />
                – collect login details<br />
                – use cookies or tracking technologies<br />
                You may freely browse the site without providing personal information.
                <br /><br />

                <strong>3. Intellectual Property</strong>
                <br />
                All content on this website—including text, images, graphics, logos, and design elements—
                is the property of KWHour unless otherwise stated. You may not reproduce, copy, distribute, 
                or modify any content without prior written permission.
                <br /><br />

                <strong>4. Accuracy of Information</strong>
                <br />
                We aim to provide accurate, up-to-date information. However, KWHour makes no guarantees regarding 
                the completeness, reliability, or accuracy of the information on the site. Content may be updated 
                or changed at any time without notice.
                <br /><br />

                <strong>5. External Links</strong>
                <br />
                Our website may contain links to third-party websites for additional information. KWHour does not 
                control or endorse these external sites and is not responsible for their content or practices.
                <br /><br />

                <strong>6. Limitation of Liability</strong>
                <br />
                KWHour shall not be held liable for any damages—direct, indirect, incidental, or consequential—
                arising from the use or inability to use this website or reliance on any information provided here.
                <br /><br />

                <strong>7. Contact Information</strong>
                <br />
                If you have any questions about these Terms or about our services, you may contact us at:
                <br />
                Email: contact@kwhour.in
                <br /><br />

                <strong>8. Changes to These Terms</strong>
                <br />
                KWHour may update these Terms of Use periodically. Continued use of the website after changes are 
                posted constitutes acceptance of the revised terms.
            </p>
            </div>
            <Footer />
        </div>
    );
};

export default Terms;
